import { parseParams } from "./helpers";

$(document).on('turbolinks:load', function() {
  $('form#actor-save-search-form').submit(function(e) {
    $('#save-search-query-field').val(JSON.stringify(parseParams(window.location.search)));
  });

});
